import React, { useState } from "react";
import "./addTraining.css";
import { addTraining } from "../../api/training";

const AddTraining = (props) => {
  const [loading, setLoading] = useState(false);
  const [video, setVideo] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChooseFiles = (e) => {
    e.target.setCustomValidity("");
    setVideo(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("name", formData.name);
    formBack.append("description", formData.description);
    formBack.append("video", video);
    addTraining(formBack).then((result) => {
      setLoading(false);
      setFormData({
        description: "",
        name: "",
      });
      setVideo(null);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  return (
    <div className="add-guideline">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="video">Video</label>
          <div style={{ position: "relative", marginTop: "16px" }}>
            {video && (
              <div className="preview-item">
                <video
                  controls
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    backgroundColor: "#000",
                  }}
                >
                  <source src={URL.createObjectURL(video)} type={video.type} />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
            <input
              type="file"
              id="videoBroker"
              name="videoBroker"
              onChange={(e) => handleChooseFiles(e)}
              accept="video/mp4"
              style={inputStyle}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity("Video broker english is required")
              }
            />
            <label htmlFor="videoBroker" style={labelStyle}>
              {video ? "Change video" : "Choose video"}
            </label>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="video">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter name"
            required
            onInvalid={(e) => e.target.setCustomValidity("Name is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="video">Description</label>
          <input
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter description"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Description is required")
            }
          />
        </div>

        {props.isSuper && (
          <>
            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add training
              </button>
            )}
          </>
        )}
      </form>
    </div>
  );
};

export default AddTraining;
